import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthGuard, I18nModule, provideConfig } from '@spartacus/core';
import { PageSlotModule } from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { KbCustomerIdDropdownModule } from '../kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { KbSubmitWarrantyClaimComponent } from './kb-submit-warranty-claim.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';

@NgModule({
  imports: [
    CommonModule,
    PageSlotModule,
    KbMyAccountLeftSideNavModule,
    KbCustomerIdDropdownModule,
    I18nModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    BsDatepickerModule
  ],
  exports: [KbSubmitWarrantyClaimComponent],
  declarations: [KbSubmitWarrantyClaimComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        SubmitWarrantyClaimFlexComponent: {
          component: KbSubmitWarrantyClaimComponent,
          guards: [AuthGuard, SecureGuard]
        }
      }
    })
  ]
})
export class KbSubmitWarrantyClaimModule { }
